import React, { useState, useCallback } from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import TrustStrip from "@/components/TrustStrip";
import TrustSection from "@/components/TrustSection";
import HowItWorks from "@/components/HowItWorks";
import SubsidySection from "@/components/SubsidySection";
import ServicesCarousel from "@/components/ServicesCarousel";
import SavingsCalculator from "@/components/SavingsCalculator";
import WorkflowSection from "@/components/WorkflowSection";
import FAQSection from "@/components/FAQSection";
import Footer from "@/components/Footer";
import LeadDialog from "@/components/LeadDialog";
import useIdleTrigger from "@/hooks/useIdleTrigger";
import { useTranslation } from "@/context/LanguageContext";

export default function Home() {
  const { t } = useTranslation();
  const [leadOpen, setLeadOpen] = useState(false);
  const [ctx, setCtx] = useState({});
  const [title, setTitle] = useState(null);
  const [subtitle, setSubtitle] = useState(null);

  const openQuote = () => {
    setCtx({});
    setTitle(null);
    setSubtitle(null);
    setLeadOpen(true);
  };

  const openCalculatorQuote = (calcCtx) => {
    setCtx(calcCtx || {});
    setTitle(t("lead.title_calc"));
    setSubtitle(null);
    setLeadOpen(true);
  };

  const scrollToCalc = () => {
    const el = document.getElementById("calculator");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  const onIdle = useCallback(() => {
    if (!leadOpen) {
      setCtx({ source: "idle_popup" });
      setTitle(t("lead.title_idle"));
      setSubtitle(t("lead.subtitle_idle"));
      setLeadOpen(true);
    }
  }, [leadOpen, t]);

  useIdleTrigger({ idleMs: 30000, onTrigger: onIdle });

  return (
    <div className="relative">
      <Navbar onCtaClick={openQuote} />
      <ServicesCarousel onRequestQuote={openQuote} isOpening />
      <Hero onQuote={openQuote} onCalc={scrollToCalc} />
      <TrustStrip />
      <TrustSection />
      <HowItWorks />
      <SubsidySection />
      <SavingsCalculator onRequestQuote={openCalculatorQuote} />
      <WorkflowSection />
      <FAQSection onContactClick={openQuote} />
      <Footer />

      <LeadDialog
        open={leadOpen}
        onOpenChange={setLeadOpen}
        context={ctx}
        title={title}
        subtitle={subtitle}
        source={ctx.source || "website"}
      />
    </div>
  );
}
